import {
  teamScopingQueryUtils,
  TeamScoping
} from 'v5/api/_common/query/team-scoping';
import { ResolvedAppScope } from '../appScope.types';

export function teamScopingFromResolvedScope(
  scope: ResolvedAppScope
): TeamScoping {
  return teamScopingQueryUtils.fromScope(scope);
}
